<template>
  <div class="content">
    <el-row class="content-line">
      <el-col :span="8" class="title">业务名称</el-col>
      <el-col :span="14" class="text">预约挂号</el-col>
    </el-row>
    <el-row class="content-line">
      <el-col :span="8" class="title">支付金额</el-col>
      <el-col :span="14" class="text" style="color: #409eff">￥{{$route.query.money}}</el-col>
    </el-row>
    <div style="height: .8rem;color: #999999;line-height: .8rem;margin-left: .3rem;">
      请选择支付方式
    </div>
    <el-row class="content-line">
      <el-col :span="2" style="margin-left: .3rem;margin-top: .2rem">
        <img src="static/img/wechatpay.png" style="width: .4rem"/>
      </el-col>
      <el-col :span="8" class="title" style="margin-left: 0">微信公众号支付</el-col>
      <el-col :span="12" class="text" style="color: #409eff;font-size: .4rem"><i class="el-icon-success"></i></el-col>
    </el-row>
    <div style="width: 100%;text-align: center;margin-top: .6rem;">
      <el-button type="primary" style="width: 6rem;font-size: .32rem" @click="pay">立即支付</el-button>
    </div>
  </div>
</template>

<script>
  import {yyguahao,yyguahao_bypay_after} from '../../api/index'
    export default {
      data(){
        return{
          orderId:''
        }
      },
      created() {
        //修改标题
        document.title = '支付'
      },
      methods:{
        pay(){
          const self = this
          let patient = this.$storage.get('patient')
          let query = this.$route.query
          yyguahao({
            birthday:patient.birth
          },{
            order_id: this.orderId,
            amount: query.money,
            // cancle_msg: "string",
            clinic_card_num: patient.clinic_num,
            clinic_patient_name: patient.clinic_patient_name,
            // create_time: "2020-07-07T03:03:46.578Z",
            dept_id: query.ksId,
            dept_name: query.ks,
            // discount: "string",
            doc_id: query.doctorId,
            doc_name: query.doctor,
            // his_serial_num: "string",
            num_source_date: query.date,
            num_source_serial_num: query.hyxlh,
            // pay_status: 0,
            // pay_time: "2020-07-07T03:03:46.578Z",
            price: query.money,
            schedule_serial_num: query.pbxlh,
            // status: 0,
            time_period: query.dated,
            // update_time: "2020-07-07T03:03:46.578Z",
            user_open_id: patient.open_id,
            HealthCardId: patient.healthCardId,
            PatientId: patient.patient_id,
            unionid:this.$storage.get('unionid'),
            // transaction_id: "string",
            // his_returncode: "string",
            // his_returnmsg: "string",
            // refund_status: "string"
          }).then(res=>{
            if(!res.IsSuccess){
              this.$message({
                message: res.Msg,
                type: 'error',
                duration:3000,
                center:true,
                offset:200
              });
            }else {
              //支付
              let wxJsonApiParam =  JSON.parse(res.Data.WxJsonData.wxJsonApiParam)
              this.orderId = res.Data.RecoredID
              function onBridgeReady() {
                WeixinJSBridge.invoke(
                  'getBrandWCPayRequest', wxJsonApiParam,
                  function(res) {
                    if(res.err_msg == "get_brand_wcpay_request:ok") {
                      self.$message({
                        message: '支付成功！',
                        type: 'success',
                        duration:3000,
                        center:true,
                        offset:200
                      });
                      // yyguahao_bypay_after({
                      //   order_id:self.orderId,
                      //   paystatus:1,
                      //   openid:self.$storage.get('openid')
                      // }).then(res=>{
                      //
                      // })
                      setTimeout(() => {
                        self.$router.push({path:'/registrationRecord'})
                      }, 500)
                    }else {
                      self.$message({
                        message: '支付失败！',
                        type: 'error',
                        duration:3000,
                        center:true,
                        offset:200
                      });
                      // yyguahao_bypay_after({
                      //   order_id:self.orderId,
                      //   paystatus:2,
                      //   openid:self.$storage.get('openid')
                      // }).then(res=>{
                      //
                      // })
                    }
                  }
                );
              }
              if(typeof WeixinJSBridge == "undefined") {
                if(document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                } else if(document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                  document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                }
              } else {
                onBridgeReady();
              }
            }
          })
        }
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    font-size: .28rem;
    background-color: #f4f4f4;
  }
  .content-line{
    height: .8rem;
    background-color: #FFFFFF;
    margin-bottom: 1px;
  }
  .title{
    line-height: .8rem;
    margin-left: .3rem;
    color: #666666;
  }
  .text{
    line-height: .8rem;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/payment.vue